<template>
<div id="apptable" v-cloak>

    <b-card header="Categorie" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
        <div class="text-left">

            <div class="my-1 row">
                <div class="col-md-3">
                    <b-form-input v-model="filter" placeholder="Cerca..." />
                </div>
                <div class="col-md-9 text-right">
                    <b-button size="md" variant="outline-primary" @click.stop="insert()">
                        Inserisci
                    </b-button>
                </div>
            </div>

            <!-- Main table element -->
            <b-table responsive v-show="showtable" id="main-table" striped hover show-empty :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @filtered="onFiltered" empty-text="Non sono stati trovati record da visualizzare" empty-filtered-text="Non sono stati trovati record corrispondenti alla tua richiesta">
                <template slot="id" scope="row">{{row.value}}</template>
                <template slot="descrizione" scope="row">{{row.value}}</template>
                <template slot="tipoVis" scope="row">{{row.value}}</template>
                <template slot="tipomenuVis" scope="row">{{row.value}}</template>
                <template slot="bloccopartecipaVis" scope="row">{{row.value}}</template>
                <template slot="ordinamento" scope="row">{{row.value}}</template>
                <template slot="allegato" scope="row">
                    <div v-if="row.value != ''">
                        <b-img fluid width="24" height="24" :src="row.value" />
                    </div>
                    <div v-else>
                        Nessuna
                    </div>
                </template>

                <template slot="modifica" scope="row">
                    <!-- We use click.stop here to prevent a 'row-clicked' event from also happening -->
                    <b-btn style="margin:0px 0px 1px 2px;" variant="warning" size="sm" @click.stop="del(row.item,row.index,$event.target)">Elimina</b-btn>
                    <b-btn style="margin:0px 0px 1px 2px;" size="sm" @click.stop="details(row.item,row.index,$event.target)">Modifica</b-btn>
                </template>
            </b-table>

            <div class="row my-1">
                <div class="col-md-8 col-sm-12">
                    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
                </div>
                <div class="col-md-4 col-sm-12 text-right">
                    <b-form-fieldset horizontal label="Righe per pagina" :label-cols="6">
                        <b-form-select :options="pageOptions" v-model="perPage" />
                    </b-form-fieldset>
                </div>
            </div>
        </div>

        <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>

    </b-card>

    <!-- Modal Component -->
    <b-modal v-model="deleteModal.show" title="Elimina">
        <p class="my-2">Confermi l'eliminazione della categoria #{{deleteModal.id}}: {{deleteModal.titolo}}?</p>
        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-right" variant="primary" @click="delItem()" style="margin: 2px;">
                Conferma
            </b-btn>
            <b-btn size="sm" class="float-right" variant="secondary" @click="deleteModal.show=false" style="margin: 2px;">
                Annulla
            </b-btn>
        </div>
    </b-modal>

</div>
</template>

<script>
import {
    NAMESPACE
} from '../config.js'

import {
    ctrlVismenu,
    ctrlViscategoria
} from '../util.js'

import {
    Categoria
} from '../classes.js'

export default {
    name: 'apptable',
    data: function () {
        return {
            deleteModal: {
                id: null,
                titolo: '',
                show: false
            },
            items: [],
            namespace: NAMESPACE,
            fields: {
                id: {
                    label: '#',
                    sortable: true
                },
                descrizione: {
                    label: 'Descrizione',
                    sortable: true
                },
                tipoVis: {
                    label: 'Tipo',
                    sortable: true
                },
                tipomenuVis: {
                    label: 'Tipo menù',
                    sortable: true
                },
                bloccopartecipaVis: {
                    label: 'Blocco partecipa',
                    sortable: true
                },
                ordinamento: {
                    label: 'Ordinamento',
                    sortable: true
                },
                allegato: {
                    label: 'Icona',
                    sortable: true
                },
                modifica: {
                    label: ' ',
                    'class': 'text-right'
                }
            },
            currentPage: 1,
            perPage: 10,
            pageOptions: [{
                text: 10,
                value: 10
            }, {
                text: 25,
                value: 25
            }, {
                text: 50,
                value: 50
            }],
            sortBy: null,
            sortDesc: false,
            filter: null,
            totalRowsFilter: null,
            modalDetails: {
                index: '',
                data: ''
            },
            error: '',
            showerror: false,
            showtable: false
        };
    },
    computed: {
        totalRows: {
            // getter
            get: function () {
                return this.totalRowsFilter || this.items.length || 0;
            },
            // setter
            set: function (newValue) {
                this.totalRowsFilter = newValue;
            }
        }
    },
    methods: {
        insert() {
            this.$router.push('/app/dettagliocategoria');
        },
        details(item, index, button) {
            this.$router.push({
                path: `/app/dettagliocategoria/${item.id}`
            });
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        getTipo(tipo) {
            var cat = new Categoria();
            return cat.getTipoByFlag(tipo);
        },
        getTipomenu(tipomenu) {
            var cat = new Categoria();
            return cat.getTipoMenuByFlag(tipomenu);
        },
        del(item, index, button) {
            this.deleteModal.id = item.id;
            this.deleteModal.titolo = item.descrizione;
            this.deleteModal.show = true;
        },
        delItem() {

            var numeroEvnCon = 0;

            var token = localStorage.getItem('token');
            this.axios.get(NAMESPACE + 'rest/eventi/id_categoria/' + this.deleteModal.id, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {
                        if (!response.data.error) {
                            if (response.data.token != null) localStorage.setItem('token', response.data.token);
                            numeroEvnCon += response.data.message.length;

                            //////////////////////////////////////////////////////////////////////
                            var token = localStorage.getItem('token');
                            this.axios.get(NAMESPACE + 'rest/convenzioni/id_categoria/' + this.deleteModal.id, {
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': token
                                    }
                                })
                                .then(response => {
                                    // JSON responses are automatically parsed.
                                    try {
                                        if (!response.data.error) {
                                            if (response.data.token != null) localStorage.setItem('token', response.data.token);
                                            numeroEvnCon += response.data.message.length;

                                            //////////////////////////////////////////////////////////////////////
                                            if (numeroEvnCon == 0) {
                                                var token = localStorage.getItem('token');
                                                this.axios.delete(NAMESPACE + 'rest/categorie/' + this.deleteModal.id, {
                                                        headers: {
                                                            'Content-Type': 'application/json',
                                                            'Authorization': token
                                                        }
                                                    })
                                                    .then(response => {
                                                        // JSON responses are automatically parsed.
                                                        try {
                                                            if (!response.data.error) {
                                                                if (response.data.token != null) localStorage.setItem('token', response.data.token);
                                                                //forse può essere fatta diversamente e meglio
                                                                for (var i = 0; i < this.items.length; i++) {
                                                                    if (this.items[i].id == this.deleteModal.id) {
                                                                        this.items.splice(i, 1); //delete
                                                                        break;
                                                                    }
                                                                }
                                                                this.deleteModal.show = false;
                                                            } else {
                                                                throw new Error(response.data.message);
                                                            }
                                                        } catch (e) {
                                                            this.deleteModal.show = false;
                                                            this.showerror = true;
                                                            this.error = "Errore: " + e.message;
                                                        }
                                                    })
                                                    .catch(e => {

                                                        this.deleteModal.show = false;
                                                        this.showerror = true;
                                                        this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                                                    });
                                            } else {
                                                alert("Impossibile eliminare la categoria #" + this.deleteModal.id + " perchè già associata ad Eventi o Convenzioni!");
                                                this.deleteModal.show = false;
                                            }
                                            //////////////////////////////////////////////////////////////////////
                                        } else {
                                            throw new Error(response.data.message);
                                        }
                                    } catch (e) {
                                        this.deleteModal.show = false;
                                        this.showerror = true;
                                        this.error = "Errore: " + e.message;
                                    }
                                })
                                .catch(e => {
                                    this.deleteModal.show = false;
                                    this.showerror = true;
                                    this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                                });
                            //////////////////////////////////////////////////////////////////////
                        } else {
                            throw new Error(response.data.message);
                        }
                    } catch (e) {
                        this.deleteModal.show = false;
                        this.showerror = true;
                        this.error = "Errore: " + e.message;
                    }
                })
                .catch(e => {
                    this.deleteModal.show = false;
                    this.showerror = true;
                    this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

        },

    },
    created: function () {

        if(!ctrlVismenu("T")){
            this.$router.replace('/accessdenied');
            return;
        }


        var token = localStorage.getItem('token');
        this.axios.get(NAMESPACE + 'rest/categorie', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                // JSON responses are automatically parsed.
                try {

                    if (!response.data.error) {

                        if (response.data.token != null) localStorage.setItem('token', response.data.token);

                        this.items = response.data.message;

                        //console.log("Items " + JSON.stringify(this.items))
                        //console.log("Items res " + JSON.stringify(response.data.message))

                        let apptable = this;

                        this.items.forEach(function (element, index) {
                            element.tipoVis = apptable.getTipo(element.tipo);
                            if(element.tipo == 'E' && !element.tipomenu){//evento
                                element.tipomenu = 'Z'; //sezioni
                            }
                            element.tipomenuVis = apptable.getTipomenu(element.tipomenu) || 'Nessuno';
                            element.bloccopartecipaVis = (element.bloccopartecipa == 'S' ? 'Sì' : 'No');
                        });

                        apptable.items = apptable.items.filter(function (element) {
                            return ctrlViscategoria(element.id);
                        });

                        this.showtable = true;

                    } else {
                        throw new Error(response.data.message);
                    }

                } catch (e) {
                    this.showerror = true;
                    this.error = "Errore: " + e.message;
                }

            })
            .catch(e => {
                this.showerror = true;
                this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
            });

    }
}
</script>
